import jsPDF from "jspdf";

export const downloadPoliciesPdf = (
  programLabelOrCode: string,
  policies: any[]
) => {
  const doc = new jsPDF();
  let y = 20;

  // Program Name (Center-aligned)
  doc.setFontSize(14);
  doc.setTextColor(0, 102, 204);
  doc.setFont("helvetica", "bold");
  doc.text(`Program: ${programLabelOrCode}`, 105, y, { align: "center" });
  y += 12;

  // Reset font for content
  doc.setFontSize(12);
  doc.setTextColor(0, 0, 0);

  policies.forEach((policy) => {
    const topPadding = 4;
    const bottomPadding = 3;

    // Add top padding
    y += topPadding;
    if (y > 270) {
      doc.addPage();
      y = 20;
    }

    // Label (name) - at top
    doc.setFont("helvetica", "bold");
    doc.text(`${policy.label}`, 10, y);
    y += 7;

    // Description - below the label
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = policy.description;
    const desc = tempDiv.textContent || tempDiv.innerText || "";

    doc.setFont("helvetica", "normal");
    const lines = doc.splitTextToSize(desc, 180);
    lines.forEach((line: string) => {
      if (y > 270) {
        doc.addPage();
        y = 20;
      }
      doc.text(line, 10, y); // Align with label (left margin = 10)
      y += 7;
    });

    // Draw bottom border
    if (y > 270) {
      doc.addPage();
      y = 20;
    }
    doc.setDrawColor(200); // Light gray
    doc.line(10, y, 200, y);

    y += bottomPadding;
  });

  doc.save(`policies_${programLabelOrCode}.pdf`);
};
